import React, {useContext, useEffect, useState} from 'react';
import block from 'bem-cn-lite';
import {Icon} from '@yandex-data-ui/common';
import statusErrorIcon from '@yandex-data-ui/cloud-components/assets/icons/status-error.svg';
import LocaleContext from 'contexts/LocaleContext';
import {CalculatorBannerConfig, getCalculatorBannerConfig} from '../config';
import YFMWrapper from 'components/YFMWrapper/YFMWrapper';

import './Banner.scss';

export enum BannerTheme {
    Danger = 'danger',
}

export interface BannerProps {
    className?: string;
}

const b = block('PricesCalculatorBanner');

const Banner: React.FC<BannerProps> = ({className}) => {
    const locale = useContext(LocaleContext);
    const [bannerConfig, setBannerConfig] = useState<CalculatorBannerConfig>();

    useEffect(() => {
        (async () => {
            const config = await getCalculatorBannerConfig(locale?.code);

            if (config?.length) {
                setBannerConfig(config[0]);
            }
        })();
    }, [locale?.code]);

    if (!bannerConfig) {
        return null;
    }

    const {title, content, theme = BannerTheme.Danger} = bannerConfig;

    const renderStatusIcon = () => {
        switch (theme) {
            case BannerTheme.Danger:
                return <Icon data={statusErrorIcon} size={24} />;

            default:
                return null;
        }
    };

    return (
        <div className={b({theme}, className)}>
            <div className={b('icon')}>{renderStatusIcon()}</div>
            <div>
                <div className={b('title')}>
                    <YFMWrapper content={title} />
                </div>
                <div className={b('content')}>
                    <YFMWrapper content={content} />
                </div>
            </div>
        </div>
    );
};

export default Banner;
